export const reusableFn = (str, length) => {
  // const finalStr = str.length > length ? `${str.slice(0, length)} ...` : str;
  return str;
};
